"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderLine = void 0;
var common_1 = require("../../../../../utils/common");
var axis_type_utils_1 = require("../../../utils/axis_type_utils");
function renderLine(ctx, _a) {
    var position = _a.axisSpec.position, size = _a.size, axisLine = _a.axisStyle.axisLine;
    if (!axisLine.visible) {
        return;
    }
    var lineProps = [];
    if (axis_type_utils_1.isVerticalAxis(position)) {
        lineProps[0] = position === common_1.Position.Left ? size.width : 0;
        lineProps[2] = position === common_1.Position.Left ? size.width : 0;
        lineProps[1] = 0;
        lineProps[3] = size.height;
    }
    else {
        lineProps[0] = 0;
        lineProps[2] = size.width;
        lineProps[1] = position === common_1.Position.Top ? size.height : 0;
        lineProps[3] = position === common_1.Position.Top ? size.height : 0;
    }
    ctx.beginPath();
    ctx.moveTo(lineProps[0], lineProps[1]);
    ctx.lineTo(lineProps[2], lineProps[3]);
    ctx.strokeStyle = axisLine.stroke;
    ctx.lineWidth = axisLine.strokeWidth;
    ctx.stroke();
}
exports.renderLine = renderLine;
//# sourceMappingURL=line.js.map